<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form @submit.prevent="filterDetailedSalesByEvent" class="search-forms">
        <v-row class="align-center">
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.search')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              clearable
            ></BaseTextField>
          </v-col>

          <v-col cols="12" md="3" sm="4" v-if="!descProduto">
            <BaseAutocomplete
              v-model="filter.product"
              :label="$t('reports.sales-by-event.event')"
              :placeholder="$t('reports.sales-by-event.select')"
              :no-data-text="$t('reports.no-info-found')"
              :loading="detailedSalesByEventLoading"
              clearable
              :disabled="storeSequencial === null"
              @click:clear="filter.payment = null"
              :items="allEvents"
              item-text="descricao"
              item-value="idproduto"
            >
            </BaseAutocomplete>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <v-select
              v-model="filter.productType"
              :label="$t('reports.general-sales.product-type')"
              :placeholder="$t('reports.general-sales.select-product-type')"
              :no-data-text="$t('reports.no-info-found')"
              :items="productTypes"
              class="rounded-lg"
              item-text="value"
              item-value="key"
              outlined
              hide-details
              dense
              clearable
            >
              <template v-slot:selection="{ item }">
                {{ translateProductType(item.key) }}
              </template>
              <template v-slot:item="{ item }">
                {{ translateProductType(item.key) }}
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <BaseSelect
              v-model="filter.payment"
              :label="$t('reports.payment-method.input')"
              :placeholder="$t('reports.payment-method.select')"
              :no-data-text="$t('reports.no-info-found')"
              :items="paymentMethods"
              item-text="key"
              item-value="value"
              clearable
              @click:clear="filter.payment = null"
            />
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <BaseSelect
              v-model="filter.channel"
              :label="$t('reports.channel-sales.input')"
              :placeholder="$t('reports.channel-sales.select')"
              :no-data-text="$t('reports.no-info-found')"
              :items="channelSales"
              item-text="value"
              item-value="key"
              clearable
              @click:clear="filter.channel = null"
            />
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              variant="filter"
              type="submit"
              :loading="detailedSalesByEventLoading"
            >
              {{ $t("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="rounded-lg"
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      :loading="detailedSalesByEventLoading"
      :headers="headers"
      :items="allDetailedSalesByEvent.info"
      :items-per-page="10"
      mobile-breakpoint="0"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.sales-per-page'),
      }"
    >
      <template v-slot:item.ultima_venda="{ item }">
        {{ formatDateTime(item.ultima_venda) || "R$ 0,00" }}
      </template>
      <template v-slot:item.valor="{ item }">
        {{ formatCurrency(item.valor) || "R$ 0,00" }}
      </template>
      <template v-slot:item.valor_item="{ item }">
        {{ formatCurrency(item.valor_item) || "R$ 0,00" }}
      </template>
      <template v-slot:item.desconto_cupom="{ item }">
        {{ formatCurrency(item.desconto_cupom) || "R$ 0,00" }}
      </template>
      <template v-slot:item.desconto_afiliado="{ item }">
        {{ formatCurrency(item.desconto_afiliado) || "R$ 0,00" }}
      </template>
      <template v-slot:item.comissao_pdv="{ item }">
        {{ formatCurrency(item.comissao_pdv) || "R$ 0,00" }}
      </template>
      <template v-slot:item.desconto_reverter_taxa="{ item }">
        {{ formatCurrency(item.desconto_reverter_taxa) || "R$ 0,00" }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ formatCurrency(item.valor_total) || "R$ 0,00" }}
      </template>

      <template
        v-for="(totais, index) in allDetailedSalesByEvent.totals"
        v-slot:body.append
      >
        <tr :key="index" class="text-end font-weight-bold total-row">
          <td class="text-start">Total</td>
          <td></td>
          <td>{{ totais.qtd_pedido }}</td>
          <td>{{ totais.qtd_itens_pedido }}</td>
          <td colspan="2"></td>
          <td>{{ formatCurrency(totais.desconto_cupom) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.desconto_afiliado) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.comissao_pdv) || "R$ 0,00" }}</td>
          <td>
            {{ formatCurrency(totais.desconto_reverter_taxa) || "R$ 0,00" }}
          </td>
          <td>{{ formatCurrency(totais.valor_total) || "R$ 0,00" }}</td>
        </tr>
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import { formatCurrency, formatDateTime } from "@/utils";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";

export default {
  name: "GeneralAnalytical",
  components: {
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    DateTimePicker,
    ExpansionPanelFilters,
  },
  props: {
    descricao: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formatCurrency,
      formatDateTime,
      filter: {
        pesquisar: "",
        product: null,
        channel: null,
        payment: null,
        productType: null,
        initDateTime: "",
        endDateTime: "",
      },
      tab: null,
      dayjs: dayjs,
      produtos: [],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "allDetailedSalesByEvent",
      "detailedSalesByEventLoading",
      "dashEvent",
      "paymentMethods",
      "channelSales",
      "allEvents",
      "isAdmin",
      "regionais",
      "descProduto",
      "idProduto",
      "dashEvent",
      "productTypes",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.general-sales.last-sale"),
          align: "start",
          sortable: false,
          value: "ultima_venda",
          width: 180,
        },
        {
          text: this.$t("reports.general-sales.tickets-products-recharges"),
          align: "start",
          sortable: false,
          value: "desc_produto",
          width: 260,
        },
        {
          text: this.$t("reports.orders"),
          align: "end",
          value: "qtd_pedido",
          width: 80,
        },
        {
          text: this.$t("reports.quantity"),
          align: "end",
          value: "qtd_itens_pedido",
          width: 80,
        },
        {
          text: this.$t("reports.sales-by-coupon.remaining-quantity"),
          align: "end",
          value: "qtd_estoque",
          width: 80,
        },
        {
          text: this.$t("reports.general-sales.unit"),
          align: "end",
          value: "valor_item",
          width: 80,
        },
        {
          text: this.$t("reports.general-sales.coupons-discounts"),
          align: "end",
          value: "desconto_cupom",
          width: 120,
        },
        {
          text: this.$t("reports.general-sales.affiliates-discounts"),
          align: "end",
          value: "desconto_afiliado",
          width: 120,
        },
        {
          text: this.$t("reports.general-sales.pos-discounts"),
          align: "end",
          value: "comissao_pdv",
          width: 120,
        },
        {
          text: this.$t("reports.general-sales.discounts-revert-fees"),
          align: "end",
          value: "desconto_reverter_taxa",
          width: 160,
        },
        {
          text: this.$t("reports.grand-total"),
          align: "end",
          value: "valor_total",
          width: 80,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "fetchDetailedSalesByEvent",
      "fetchPaymentMethodOptions",
      "fetchChannelSalesOptions",
      "fetchEvents",
      "fetchRegionais",
      "fetchProductTypes",
    ]),
    ...mapMutations([
      "setDetailedSalesByEventLoading",
      "setReportsFilter",
      "setDetailedSalesByEvent",
    ]),
    filterDetailedSalesByEvent() {
      this.setDetailedSalesByEventLoading(true);
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_ped_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_ped_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        idproduto: this.idProduto ? this.idProduto : this.filter.product,
        canal_venda: this.filter.channel,
        forma_pagamento: this.filter.payment,
        pesquisar: this.filter.pesquisar,
        tipo: this.filter.productType,
      });

      this.setReportsFilter(filter);
      this.fetchDetailedSalesByEvent(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterDetailedSalesByEvent();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
    translateProductType(productType) {
      return productType === "INGRESSO"
        ? this.$t("reports.ticket")
        : productType === "PRODUTO"
        ? this.$t("reports.products-sales.product")
        : this.$t("reports.general-sales.recharge");
    },
  },
  mounted() {
    if (this.$route.path.includes("/analitico-geral")) {
      this.filterDetailedSalesByEvent();
    }
    this.fetchPaymentMethodOptions();
    this.fetchChannelSalesOptions();
    this.fetchProductTypes();
    if (this.storeSequencial) {
      this.fetchEvents({
        producerId: this.storeSequencial,
      });
    }
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      product: "",
      channel: null,
      payment: null,
      productType: null,
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>
<style scoped></style>
